import AboutCard from './aboutCard'
export default AboutCard
